import { Store } from '@ngrx/store';
import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { datiIdentificativiDelegheDateRules } from './dati-identificativi-deleghe-date.rules';
import { datiIdentificativiCodiciRappresentanteRules } from './dati-identificativi-codici-rappresentante.rules';
import { datiIdentificativiRevisioneAttivitaRules } from './dati-identificativi-revisione-attivita.rules';
import { datiIdentificativiSediRules } from './dati-identificativi-sedi.rules';
import { datiIdentificativiMutualitaAlboRules } from './dati-identificativi-mutualita-albo.rules';
import { datiIdentificativiCrossSectionRules } from './dati-identificativi-cross-section.rules';

export const DatiIdentificativiRules = (store: Store<Revisione53State>): FormGroupRules => ({
    ...datiIdentificativiDelegheDateRules,
    ...datiIdentificativiCodiciRappresentanteRules,
    ...datiIdentificativiRevisioneAttivitaRules,
    ...datiIdentificativiSediRules,
    ...datiIdentificativiMutualitaAlboRules,
    ...datiIdentificativiCrossSectionRules(store),
});

export const datiIdentificativiFormValidators = (store: Store<Revisione53State>) => Object.values(DatiIdentificativiRules(store));
